import { VisualizationType, EditableComponent } from '../../models';
import { VisualizationTypeStrategy } from '../models';
import { TimeSeriesPropertiesPanel } from './TimeSeriesPropertiesPanel';
import TimeSeriesEditor from './TimeSeries.json';
import { isValidTimeSeriesData } from './isValidTimeSeriesData';

export class TimeSeries implements VisualizationTypeStrategy {
  public getEditableComponent(): EditableComponent {
    return {
      visualizationType: VisualizationType.TIME_SERIES,
      name: 'editable:TimeSeries',
      displayName: 'Time Series',
      displayIcon: 'ChartType.Line',
      editorTemplate: TimeSeriesEditor,
      propertiesPanel: TimeSeriesPropertiesPanel,
      isValidData: isValidTimeSeriesData,
    };
  }
}
